import { green } from '@ant-design/colors';
import {
  CheckCircleOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import TableAndFilters from '../../components/TableAndFilters';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { fieldTypes } from '../../utils/filter-utils';

const styles = {
  menuAction: {
    marginLeft: 10
  }
};

function PromocionList(props) {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: '10px',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Empresa',
      dataIndex: ['empresa', 'nombre'],
      width: '20%',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Código',
      dataIndex: 'codigo',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Fecha de Inicio',
      dataIndex: 'fecha_inicio',
      filterType: fieldTypes.DATE,
      sortable: true,
      defaultSortOrder: 'descend'
    },
    {
      title: 'Fecha de Vigencia',
      dataIndex: 'fecha_fin',
      filterType: fieldTypes.DATE,
      sortable: true
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Ver Promocion">
            <Button
              type="text"
              icon={<EyeOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`promociones/view/${record.id}`)}
            />
          </Tooltip>
          <Tooltip title="Editar Promoción">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`promociones/form/${record.id}`)}
            />
          </Tooltip>
          <Tooltip title={record.activo ? 'Desactivar' : 'Activar'}>
            <Button
              type="text"
              style={record.activo ? { color: green.primary } : {}}
              danger={!record.activo}
              icon={<CheckCircleOutlined />}
              size="middle"
              loading={loadingState === record.id}
              onClick={() => toggle(record)}
            />
          </Tooltip>
        </Space>
      ),
      align: 'left'
    }
  ];
  const [data, setData] = useState([]);
  const [loadingState, setLoadingState] = useState(0);
  const history = useHistory();

  const toggle = async (record) => {
    try {
      setLoadingState(record.id);
      if (record.activo) {
        await instanceRef.instance.post(`promocion/disable/${record.id}`, {});
      } else {
        await instanceRef.instance.post(`promocion/enable/${record.id}`, {});
      }
      setData({
        ...data,
        rows: data.rows.map((item) => {
          if (item.id === record.id) {
            // eslint-disable-next-line no-param-reassign
            item.activo = !record.activo;
          }
          return item;
        })
      });
    } catch (error) {
      errorHandler(error);
    }
    setLoadingState(0);
  };

  const tableRef = useRef(null);

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  return (
    <ResponsiveContainer size="large">
      <TableAndFilters
        ref={tableRef}
        withGeneralFilter
        url="/promocion"
        title="Promociones"
        columns={columns}
        showTable
        extra={[
          <Button
            key="2"
            type="dashed"
            shape="round"
            icon={<PlusOutlined />}
            size="middle"
            onClick={() => props.history.push(`promociones/form`)}
            style={styles.menuAction}
          >
            Agregar
          </Button>
        ]}
      />
    </ResponsiveContainer>
  );
}

export default PromocionList;
